/* tslint:disable */

/* eslint-disable */

/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import type { AxiosInstance, AxiosPromise, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";

// @ts-ignore
import {
  BASE_PATH,
  BaseAPI,
  COLLECTION_FORMATS,
  RequestArgs,
  RequiredError,
  operationServerMap,
} from "../base";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  createRequestFunction,
  serializeDataIfNeeded,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  toPathString,
} from "../common";
import type { Configuration } from "../configuration";
// @ts-ignore
import { AccountsAndSessionsCountByTypeDto } from "../models";

/**
 * UtilControllerApi - axios parameter creator
 * @export
 */
export const UtilControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} domain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountsAndSessionCountByType: async (
      domain: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("accountsAndSessionCountByType", "domain", domain);
      const localVarPath = `/api/v2/util/{domain}/account-and-session-count/by-types`.replace(
        `{${"domain"}}`,
        encodeURIComponent(String(domain))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UtilControllerApi - functional programming interface
 * @export
 */
export const UtilControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UtilControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} domain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountsAndSessionCountByType(
      domain: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AccountsAndSessionsCountByTypeDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountsAndSessionCountByType(
        domain,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["UtilControllerApi.accountsAndSessionCountByType"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * UtilControllerApi - factory interface
 * @export
 */
export const UtilControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UtilControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} domain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountsAndSessionCountByType(
      domain: string,
      options?: any
    ): AxiosPromise<AccountsAndSessionsCountByTypeDto> {
      return localVarFp
        .accountsAndSessionCountByType(domain, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UtilControllerApi - object-oriented interface
 * @export
 * @class UtilControllerApi
 * @extends {BaseAPI}
 */
export class UtilControllerApi extends BaseAPI {
  /**
   *
   * @param {string} domain
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilControllerApi
   */
  public accountsAndSessionCountByType(domain: string, options?: RawAxiosRequestConfig) {
    return UtilControllerApiFp(this.configuration)
      .accountsAndSessionCountByType(domain, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
